import { SelectFieldOrderBy } from "@generation/schema-core/src/client/model/options/selectFieldOrderByEnum";
import { ISimpleForm } from "@klantondersteuning/shared/src/form/interface/SimpleForm/ISimpleForm";
import { PredefinedFieldType } from "@klantondersteuning/shared/src/form/interface/SimpleForm/PredefinedFieldType";
import { RegelingOptions } from "@klantondersteuning/shared/src/form/interface/SimpleForm/RegelingOptions";
import { translate } from "@opencak-klantondersteuning/shared";
import { voorWieSteltUDeVraagOptions } from "../utils/voorWieSteltUDeVraagOptions";
import { watIsUwVraagOptions } from "../utils/watIsUwVraagOptions";
import { dependsOnRegelingWlz, dependsOnRegelingWmo } from "./dependsOnRegeling";
import { dependsOnShowIfIemandAnders } from "./dependsOnShowIfIemandAnders";
import { dependsOnZorgverzekeringBuitenland } from "./dependsOnZorgverzekeringBuitenland";
import { showBsnInput } from "./showBsnInput";
import { showGeboortedatumInput } from "./showGeboortedatumInput";
import { showToelichting } from "./showToelichting";
import { showVoorWieSteltUEenVraag } from "./showVoorWieSteltUEenVraag";
import { showVraagBijlageInput } from "./showVraagBijlageInput";

export const GetSimpleContactFormulier = (): ISimpleForm => {
  return {
    name: "contact-formulier",
    steps: [
      {
        name: translate("Inleiding"),
        isIntroduction: true
      },
      {
        name: translate("ContactFormulierFormulierStapMijnVraag"),
        Sections: [
          {
            name: "stap_contactvraag__contactvraag",
            fields: {
              regeling: {
                predefinedFieldType: PredefinedFieldType.regeling,
                isRequired: true,
                regelingOptions: [
                  RegelingOptions.MedicijnenMeeOpReis,
                  RegelingOptions.Gemoedsbezwaarden,
                  RegelingOptions.Onverzekerden,
                  RegelingOptions.BetalingsachterstandZorgpremie,
                  RegelingOptions.Buitenland,
                  RegelingOptions.Wlz,
                  RegelingOptions.WmoAT,
                  RegelingOptions.Onbekend
                ],
                orderOptionsBy: {
                  orderBy: SelectFieldOrderBy.Alphabetical,
                  exclusions: [RegelingOptions.Onbekend]
                }
              },
              waaroverGaatUwVraagWlz: {
                type: "select",
                validate: {
                  isRequired: {
                    value: true
                  }
                },
                ui: {
                  flexDirection: "column"
                },
                dependsOn: dependsOnRegelingWlz,
                options: watIsUwVraagOptions
              },
              waaroverGaatUwVraagWmo: {
                type: "select",
                validate: {
                  isRequired: {
                    value: true
                  }
                },
                ui: {
                  flexDirection: "column"
                },
                dependsOn: dependsOnRegelingWmo,
                options: watIsUwVraagOptions
              },
              voorWieSteltUEenVraag: {
                type: "select",
                validate: {
                  isRequired: {
                    value: true
                  }
                },
                ui: {
                  flexDirection: "column"
                },
                nestedDependsOn: showVoorWieSteltUEenVraag,
                options: voorWieSteltUDeVraagOptions()
              },
              vraag: {
                predefinedFieldType: PredefinedFieldType.textArea,
                nestedDependsOn: showVraagBijlageInput,
                isRequired: true
              },
              bijlage: {
                predefinedFieldType: PredefinedFieldType.bijlage,
                nestedDependsOn: showVraagBijlageInput
              },
              toelichting: {
                predefinedFieldType: PredefinedFieldType.textArea,
                nestedDependsOn: showToelichting
              }
            }
          }
        ]
      },
      {
        name: translate("MijnGegevens"),
        Sections: [
          {
            name: "stap_contactgegevens__contactgegevens",
            fields: {
              /* Altijd uitvragen */
              voorletters: {
                predefinedFieldType: PredefinedFieldType.voorletters,
                isRequired: true
              },
              achternaam: {
                predefinedFieldType: PredefinedFieldType.achternaam,
                isRequired: true,
                autoComplete: true
              },

              /* Als het gaat om een persoonlijk dossier (of als de vorige opties altijd een persoonlijk dossier betreffen)
              Toon dan onderstaande 2 van de onderstaande 3 velden. */
              bsn: {
                predefinedFieldType: PredefinedFieldType.bsn,
                isRequired: true,
                nestedDependsOn: showBsnInput
              },
              /* Bij BTL klantId i.p.v. BSN */
              klantId: {
                predefinedFieldType: PredefinedFieldType.cakKenmerk,
                dependsOn: dependsOnZorgverzekeringBuitenland
              },
              geboortedatum: {
                predefinedFieldType: PredefinedFieldType.geboortedatum,
                nestedDependsOn: showGeboortedatumInput
              },

              email: {
                predefinedFieldType: PredefinedFieldType.email,
                isRequired: true,
                autoComplete: true
              },
              telefoonnummer: {
                predefinedFieldType: PredefinedFieldType.telefoonnummer,
                autoComplete: true
              }
            }
          },
          {
            name: "stap_contactgegevens__voorKlant",
            fields: {
              voorKlantVoorletters: {
                predefinedFieldType: PredefinedFieldType.voorletters,
                isRequired: true
              },
              voorKlantAchternaam: {
                predefinedFieldType: PredefinedFieldType.achternaam,
                isRequired: true
              },
              voorKlantBsn: {
                predefinedFieldType: PredefinedFieldType.bsn,
                isRequired: true
              },
              voorKlantGeboortedatum: {
                predefinedFieldType: PredefinedFieldType.geboortedatum,
                isRequired: true
              }
            },
            dependsOn: dependsOnShowIfIemandAnders
          }
        ]
      }
    ]
  };
};
